<template>
	<section class="mx-auto w-full max-w-container" :class="{'my-8 flex sm:hidden': !alwaysVisible && index !== null, 'hidden sm:flex': !alwaysVisible && index === null }" v-if="stories">
		<div class="mx-4">
			<div class="flex flex-wrap -mx-4">
				<div class="grid grid-cols-1 md:grid-cols-3 gap-4" v-html="stories"></div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	name: "BrandStories",
	props: {
		entryId: {
			type: Number,
			required: true
		},
		index: {
			type: Number,
			required: false
		},
        alwaysVisible: {
            type: Boolean,
            required: false
        }
	},
	data() {
		return {

		}
	},
	computed: {
		stories() {
			if (this.index !== null) {
				return this.$store.state.brandStories[this.index] ?? null;
			}

			return this.$store.state.brandStories.join('');
		}
	},

	async mounted() {
		await this.$store.dispatch('getBrandStories', {
			entryId: this.entryId
		});

		// const result = await axios.postForm('/actions/site/brand-stories', ;
		// this.stories = result?.data[0] ?? null;
	}
}
</script>
